import React, { useState, useEffect } from "react";
import "./OpenHoursAdvanced.scss";

import ListOfHoursSimple, { ILocation } from "./ListOfHoursSimple";
import { mockOpenHours } from "./mockOpenHoursSimple";

interface OpenHoursProps {
  allOpen?: boolean;
  mobileBreakpoint?: number;
}

const OpenHours = ({
  allOpen = false,
  mobileBreakpoint = 768,
}: OpenHoursProps) => {
  const [skiPassDetails, setSkiPassDetails] = useState<ILocation | undefined>(
    undefined
  );
  const [skiRentalDetails, setSkiRentalDetails] = useState<
    ILocation | undefined
  >(undefined);
  const [skiSchoolDetails, setSkiSchoolDetails] = useState<
    ILocation | undefined
  >(undefined);
  const [restaurantsDetails, setRestaurantsDetails] = useState<
    ILocation | undefined
  >(undefined);
  const [isMobile, setIsMobile] = useState<boolean>(false);

  useEffect(() => {
    const checkIsMobile = () => {
      setIsMobile(window.innerWidth < mobileBreakpoint);
    };

    checkIsMobile();

    window.addEventListener("resize", checkIsMobile);

    return () => {
      window.removeEventListener("resize", checkIsMobile);
    };
  }, [mobileBreakpoint]);

  useEffect(() => {
    setSkiPassDetails(mockOpenHours.skiPass);
    setSkiRentalDetails(mockOpenHours.skiRental);
    setSkiSchoolDetails(mockOpenHours.skiSchool);
    setRestaurantsDetails(mockOpenHours.restaurant);
  }, []);

  const locations = [
    skiPassDetails,
    restaurantsDetails,
    skiRentalDetails,
    skiSchoolDetails,
  ].filter((location) => location && location.openHours.length > 0);

  const duplicatedLocations = [...locations, ...locations];

  return (
    <div className="berg-components-open-hours-wrapper">
      <div className="berg-components-open-hours">
        <div className="scrolling-container">
          <div className="scrolling-content">
            {duplicatedLocations.map((location, index) => (
              <div
                key={`${location?.id || "loc"}-${index}`}
                className="hours-item"
              >
                <ListOfHoursSimple
                  openHours={location?.openHours || []}
                  name={location?.name || ""}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default OpenHours;
